import { Fragment, type CSSProperties } from "react";

/** 45 → 45 min, 80 → 1h 20min, 1510 → 1d 1h 10min. Zero parts are dropped above an hour. */
export function durationParts(totalMinutes: number): { value: number; unit: string }[] {
  const total = Math.max(0, Math.floor(totalMinutes));
  if (total < 60) return [{ value: total, unit: "min" }];

  return [
    { value: Math.floor(total / 1440), unit: "d" },
    { value: Math.floor((total % 1440) / 60), unit: "h" },
    { value: total % 60, unit: "min" },
  ].filter((p) => p.value > 0);
}

export function formatDuration(totalMinutes: number): string {
  return durationParts(totalMinutes).map((p) => `${p.value}${unitLabel(p.unit)}`).join(" ");
}

function unitLabel(unit: string) {
  return unit === "min" ? " min" : unit;
}

export function Duration({
  minutes,
  valueStyle,
  unitStyle,
}: {
  minutes: number;
  valueStyle?: CSSProperties;
  unitStyle?: CSSProperties;
}) {
  return (
    <span style={{ whiteSpace: "nowrap" }}>
      {durationParts(minutes).map((p, i) => (
        <Fragment key={p.unit}>
          {i > 0 && " "}
          <span style={valueStyle}>{p.value}</span>
          <span style={unitStyle}>{unitLabel(p.unit)}</span>
        </Fragment>
      ))}
    </span>
  );
}
